export enum FormChangeStatus {
  PENDING = 'PENDING',
  VALID = 'VALID',
  INVALID = 'INVALID'
}
